module.exports = __webpack_public_path__ + "static/img/ic_convience_on@2x.8d4c3c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_convience_on@2x.png
// module id = hsut
// module chunks = 1